import { useMediaQuery } from "react-responsive";
import { UnorderedListOutlined,CloseOutlined } from '@ant-design/icons';

import styles from './index.module.scss'

import Slider from '../Slider/index'
import MobileMenu from '../MobileMenu'

import { Link } from 'react-router-dom'

import logo from '@/assets/image/logo.png'
import { useState,useEffect } from 'react'

const Header = () => {
 const isDesktop = useMediaQuery({ minWidth: 1151 });
 const isMobile = useMediaQuery({ maxWidth: 1150 });
 const [showHeader, setShowHeader] = useState(true);
 const [lastScrollY, setLastScrollY] = useState(0);
 const [isMenu, setMenu] = useState(false)

 const handleMenu = () => {
  setMenu(!isMenu)
 }

 useEffect(() => {
  const handleScroll = () => {
   const currentScrollY = window.scrollY;

   // 向下滚动且滚动超过 50px，就隐藏
   if (currentScrollY > lastScrollY && currentScrollY > 50) {
    setShowHeader(false);
   }
   // 向上滚动则显示
   else if (currentScrollY < lastScrollY) {
    setShowHeader(true);
   }

   setLastScrollY(currentScrollY);
  };

  window.addEventListener('scroll', handleScroll);

  return () => window.removeEventListener('scroll', handleScroll);
 }, [lastScrollY]);

 return (
  <header className={`${!showHeader&&styles.hideHide} ${styles.header} flex items-center`}>
   {
    isDesktop && <div className={`${styles.head} w-1340 flex items-center justify-between`}>
     <Link to={"/"}><img src={logo} className={styles.logo} alt="VISHWA" /></Link>

     <Slider />

    </div>
   }

   {
    isMobile && <div className={`${styles.head}  relative flex`}>
     <div className={`${styles.slider} flex flex-just align-items`}>
      <MobileMenu isMenu={isMenu} setMenu={setMenu}/>
      <Link to={"/"}><img src={logo} className={styles.logo} alt="VISHWA" /></Link>
      {
       isMenu?(
         <CloseOutlined className={`${styles.slider_icon}`} onClick={() => handleMenu()}/>
       ):(
         <UnorderedListOutlined className={`${styles.slider_icon}`} onClick={() => handleMenu()} />
       )
      }
     </div>
    </div>
   }
  </header>
 )
}

export default Header